/**
 * Payments module types for core-js
 */

import type { ApiService } from '../core/types';

/**
 * Configuration for PaymentsClient
 */
export interface PaymentsClientConfig {
    /**
     * The API service used to make HTTP requests.
     * Consumers provide their own implementation so they can attach their
     * own auth headers, base URL, etc.
     */
    apiService: ApiService;
}

/**
 * The result returned from continuePayment().
 * Mirrors the shape of the /api/public/v1/payments/continue response.
 */
export interface PaymentContinueResult {
    id?: string;
    /** e.g. 'succeeded' | 'pending' | 'declined' | 'failed' */
    status: string;
    /**
     * If the payment requires another action after being resumed
     * (e.g. a second 3DS challenge), this will be set.
     * 'none' means no further action is needed.
     */
    requireAction?: string;
    requireActionData?: unknown;
    [key: string]: unknown;
}

/**
 * Error codes for PaymentsClientError
 */
export enum PaymentsClientErrorCode {
    CONTINUE_PAYMENT_FAILED = 'CONTINUE_PAYMENT_FAILED',
    MISSING_PAYMENT_ID = 'MISSING_PAYMENT_ID',
}

/**
 * Error thrown by PaymentsClient
 */
export class PaymentsClientError extends Error {
    constructor(
        public code: PaymentsClientErrorCode,
        message: string,
        public details?: unknown,
    ) {
        super(message);
        this.name = 'PaymentsClientError';
    }
}
